module.exports = __webpack_public_path__ + "c8bcc9e8e1f99c57ee1e4a5bb74b2a2f.pdf";